import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import { Home, ExitToApp } from '@mui/icons-material';
import logo from '../assets/logo.jpg';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const CustomAppBar = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user`, { withCredentials: true });
                setUser(response.data);
            } catch (error) {
                console.error('Error al obtener el usuario:', error);
            }
        };

        fetchUser();
    }, []);

    const handleLogout = async () => {
        try {
            await axios.post(`${API_URL}/api/logout`, {}, { withCredentials: true });
            localStorage.removeItem('user');
            setUser(null);
            navigate('/login');
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        }
    };

    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1,backgroundColor: '#4682b4'  }}>
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={() => navigate('/home')}
                    sx={{ mr: 2, ml: 2 }} // Añadir margen a la izquierda para separar del logo
                >
                    <img src={logo} alt="Logo de la Empresa" style={{ width: 40, marginRight: 16 }} />
                </IconButton>
                {user && (
                    <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                        Bienvenido, {user.username}
                    </Typography>
                )}
                <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                    Medicare
                </Typography>
                <IconButton color="inherit" onClick={() => navigate('/home')}>
                    <Home />
                </IconButton>
                {user ? (
                    <IconButton color="inherit" onClick={handleLogout}>
                        <ExitToApp />
                    </IconButton>
                ) : (
                    <IconButton color="inherit" onClick={() => navigate('/login')}>
                        <ExitToApp />
                    </IconButton>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default CustomAppBar;
